import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ShareLinkDialog } from '../../../components';
import { AdminProgressBar } from '../../../components/AdminProgressBar';
import { PartnerContext, PatientTabsContext } from '../../../lib/contexts';
import useBenefitDetails from '../../../lib/hooks/useBenefitDetails';
import useMetric from '../../../lib/hooks/useMetric';
import { filterMainBenefitDetails } from '../../../lib/contexts/BenefitDetailsContext';
import BioBox from '../../../components/BioBox';

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
}));

const PatientBioBox = () => {
  const classes = useStyles();

  const { state: partnerState } = useContext(PartnerContext);
  const {
    state: { currentTab },
  } = useContext(PatientTabsContext);
  const [showShareLink, setShowShareLink] = useState(false);
  const [patientBenefitDetails, setPatientBenefitDetails] = useState(null);

  // Default data to load
  let { isLoading, data } = useMetric('bio', currentTab.id);
  let { isLoading: assessmentLoading, data: assessmentData } = useMetric('latest_assessments', currentTab.id);
  let { isLoading: checkinHistoryLoading, data: checkinHistoryData } = useMetric('checkin_history', currentTab.id);

  // Process data
  data = data ? data.metric.value : data;
  assessmentData = assessmentData ? assessmentData.metric.value : assessmentData;
  checkinHistoryData = checkinHistoryData ? checkinHistoryData.metric.value : checkinHistoryData;

  const dataLoading = isLoading || assessmentLoading || checkinHistoryLoading;

  const { data: benefitDetailsData } = useBenefitDetails(currentTab.id);

  useEffect(() => {
    const temp = filterMainBenefitDetails(benefitDetailsData?.data);
    setPatientBenefitDetails(temp);
  }, [benefitDetailsData]);

  const modifiedWorkflowURL = useMemo(() => {
    if (currentTab.workflowShareUrl) {
      const url = currentTab.workflowShareUrl;
      return url.slice(0, url.indexOf('&aggregate=1')) + url.slice(url.indexOf('#'));
    }
  }, [currentTab.workflowShareUrl]);

  if (dataLoading) {
    return (
      <Grid
        container
        item
        xs={12}
        style={{ margin: '260px auto 260px', display: 'block' }}
      >
        <AdminProgressBar style={{ width: '75%' }} />
      </Grid>
    );
  }

  return (
    <Grid
      item
      className={classes.grow}
      sx={{
        width: '100%',
        minWidth: '360px',
      }}
    >
      <BioBox
        bioData={{
          ...currentTab,
          ...data,
          checkinHistoryDate:
            checkinHistoryData?.createdAt ||
            (Array.isArray(checkinHistoryData) && checkinHistoryData.length > 0
              ? checkinHistoryData[0].createdAt
              : null),
        }}
        assessmentData={assessmentData}
        showAvatar={true}
        firstName={currentTab.firstName}
        lastName={currentTab.lastName}
        showCopyLink={true}
        onCopyLink={() => setShowShareLink(true)}
        showProgramInfo={partnerState?.is_tangelo}
        programInfo={patientBenefitDetails}
        isProvider={true}
      />

      {showShareLink && currentTab && (
        <ShareLinkDialog
          link={modifiedWorkflowURL || window.location.href}
          handleClose={() => setShowShareLink(false)}
        />
      )}
    </Grid>
  );
};

export default PatientBioBox;
